module.exports = __webpack_public_path__ + "img/photo.c5a0e113.png";